import type { CertificateProviderStatus } from "@cx/contracts";
import { certificateState, formatDateBR, todayInSaoPaulo } from "@cx/domain";
import type { Tone } from "@cx/ui";

/** Rótulos da tela do certificado A1 (T2.1). */

/** dd/mm/aaaa de um instante, no fuso de São Paulo. */
export const dateBR = (iso: string) => formatDateBR(todayInSaoPaulo(new Date(iso)));

/** Impressão digital/série em pares separados por ":" (como o Windows e o OpenSSL mostram). */
export const hexGroups = (hex: string) => hex.match(/.{1,2}/g)?.join(":") ?? hex;

/** Situação pela validade: verde, amarelo a até 30 dias, vermelho a até 7 dias e vencido. */
export function certificateBadge(validTo: string, now = new Date()): { tone: Tone; label: string } {
  const s = certificateState(validTo, now);
  if (s.kind === "expired") return { tone: "danger", label: "Vencido" };
  if (s.kind === "valid") return { tone: "success", label: "Válido" };
  const label =
    s.daysLeft <= 0 ? "Vence hoje" : s.daysLeft === 1 ? "Vence amanhã" : `Vence em ${s.daysLeft} dias`;
  return { tone: s.daysLeft <= 7 ? "danger" : "warning", label };
}

export const PROVIDER_STATUS_LABEL: Record<CertificateProviderStatus, string> = {
  pending: "Enviando ao provedor fiscal",
  registered: "Cadastrado no provedor fiscal",
  failed: "Falhou no provedor fiscal",
  disabled: "Não enviado (provedor fiscal desligado)",
};
export const PROVIDER_STATUS_TONE: Record<CertificateProviderStatus, Tone> = {
  pending: "info",
  registered: "success",
  failed: "danger",
  disabled: "secondary",
};

/** O sino mostra até 99. */
export const notificationBadge = (unread: number) => Math.min(unread, 99);
